import axios from "axios";

axios.interceptors.request.use(
  async config => {
    const newConfig = config;
    // const authToken = window.localStorage.getItem("authToken");

    if (window.appBridgeApp) {
      // Send token to your backend via HTTPS
      // ...
      if (config.url.indexOf("amazonaws") > -1) {
        return Promise.resolve(newConfig);
      }
      console.log("sending token");
      // eslint-disable-next-line
      const sessionToken = await shopify.idToken();
      newConfig.headers.post.Authorization = `Bearer ${sessionToken}`;
      newConfig.headers.get.Authorization = `Bearer ${sessionToken}`;
      newConfig.headers.put.Authorization = `Bearer ${sessionToken}`;
      newConfig.headers.delete.Authorization = `Bearer ${sessionToken}`;
      return Promise.resolve(newConfig);
    } else if (localStorage.getItem("authToken")) {
      const sessionToken = localStorage.getItem("authToken");
      newConfig.headers.post.Authorization = `${sessionToken}`;
      newConfig.headers.get.Authorization = `${sessionToken}`;
      newConfig.headers.put.Authorization = `${sessionToken}`;
      newConfig.headers.delete.Authorization = `${sessionToken}`;
      return Promise.resolve(newConfig);
    }
    return newConfig;
  },
  error =>
    // Do something with request error
    Promise.reject(error)
);

export default {
  post(url, request) {
    return axios
      .post(`${window.serverURL}${url}`, request)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  },
  get(url) {
    return axios
      .get(`${window.serverURL}${url}`)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  },
  put(url, request) {
    return axios
      .put(`${window.serverURL}${url}`, request)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  },
  delete(url, request) {
    return axios
      .delete(`${window.serverURL}${url}`, request)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  },
  postSkipAuth(url, request) {
    return axios
      .post(`${window.serverURL}${url}`, request)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  }
};
